
import { Component, Prop, Vue } from 'vue-property-decorator';
import StoreFinder from '../store-finder.vue';
import { container } from '../lib/container';
import { SearchStorage } from 'src/lib/core/storage/SearchStorage';
import { ContainerTypes } from '../lib/core/types/ContainerTypes';

const searchStorage = container.get<SearchStorage>(ContainerTypes.SearchStorage);

@Component({
	components: { StoreFinder }
})
export default class FilialfinderPage extends Vue {
	@Prop() path!: string;

	lat = 51.142796;
	lng = 10.502827;
	zoom = 7;
	bbox = '5.988658,47.302488,15.016996,54.983104';
	apiKey = '/UPZjd3W6GoUfx5mrGtMCHeiKD1gcNZBAnw05tgHxDs=';

	mounted() {
		const center = searchStorage.map.position;
		if (!isNaN(searchStorage.map.zoom)) {
			this.zoom = searchStorage.map.zoom;
		}
		if (!isNaN(center.lat) && !isNaN(center.lng)) {
			this.lat = center.lat;
			this.lng = center.lng;
		}
	}
}
